import { useState } from "react";
import "./restaurant-loyalty.styles.scss";
import PointsSettings from "./pointsSettings/pointsSettings.component";
import RewardsSettings from "./rewardsSettings/rewardsSettings.component";
import ComboSettings from "./comboSettings/comboSettings.component";
const RestaurantLoyalty = () => {
  const [pointsClass, setPointsClass] = useState("rl-left-option active");
  const [rewardsClass, setRewardsClass] = useState("rl-left-option");
  const [comboClass, setComboClass] = useState("rl-left-option");

  const [currentPane, setCurrentPane] = useState("points");
  const changePane = (pane) => {
    setCurrentPane(pane);
    if (pane === "points") {
      setPointsClass("rl-left-option active");
      setRewardsClass("rl-left-option");
      setComboClass("rl-left-option");
    } else if (pane === "rewards") {
      setPointsClass("rl-left-option");
      setRewardsClass("rl-left-option active");
      setComboClass("rl-left-option");
    } else if (pane === "combos") {
      setPointsClass("rl-left-option");
      setRewardsClass("rl-left-option");
      setComboClass("rl-left-option active");
    }
  };
  return (
    <div className="restaurant-loyalty-container">
      {window.innerWidth > 1024 ? (
        <div className="restaurant-loyalty-desktop">
          <div className="restaurant-loyalty-left">
            <div className="restaurant-loyalty-left-header">
              <span className="restaurant-loyalty-left-title">
                Choose from the following
              </span>
            </div>
            <div className="restaurant-loyalty-left-options">
              <span
                className={pointsClass}
                onClick={() => changePane("points")}
              >
                Points settings
              </span>
              <span
                className={rewardsClass}
                onClick={() => changePane("rewards")}
              >
                Rewards settings
              </span>
              <span className={comboClass} onClick={() => changePane("combos")}>
                Combo menu settings
              </span>
            </div>
          </div>
          <div className="restaurant-loyalty-right">
            {currentPane === "points" && <PointsSettings />}
            {currentPane === "rewards" && (
              <RewardsSettings changeFunction={changePane} />
            )}
            {currentPane === "combos" && <ComboSettings />}
          </div>
        </div>
      ) : (
        <div className="restaurant-loyalty-mobile">
          <div className="restaurant-loyalty-left">
            <div className="restaurant-loyalty-left-header">
              <span className="restaurant-loyalty-left-title">
                Choose from the following
              </span>
            </div>
            <div className="restaurant-loyalty-left-options">
              <span
                className={pointsClass}
                onClick={() => changePane("points")}
              >
                Points settings
              </span>
              <span
                className={rewardsClass}
                onClick={() => changePane("rewards")}
              >
                Rewards settings
              </span>
              <span className={comboClass} onClick={() => changePane("combos")}>
                Combo menu settings
              </span>
            </div>
          </div>
          <div className="restaurant-loyalty-right">
            {currentPane === "points" && <PointsSettings />}
            {currentPane === "rewards" && (
              <RewardsSettings changeFunction={changePane} />
            )}
            {currentPane === "combos" && <ComboSettings />}
          </div>
        </div>
      )}
    </div>
  );
};
export default RestaurantLoyalty;
